import { apiSlice } from "../../slices/apiSlice";

const headers = { Modulecima: "Agentexx" };

export const agentApiSlice = apiSlice.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    chatAgent: builder.mutation({
      query: (parameters) => ({
        url: `/Agentexx/chat`,
        method: "POST",
        headers,
        body: parameters,
      }),
    }),
    confirmAgent: builder.mutation({
      query: (parameters) => ({
        url: `/Agentexx/confirm`,
        method: "POST",
        headers,
        body: parameters,
      }),
    }),
  }),
});

export const { useChatAgentMutation, useConfirmAgentMutation } = agentApiSlice;
